import {
  ProactiveMessageResponse,
  queryProactiveMessages,
} from '@akin-home/chat/frontend';
import { useEffect } from 'react';

interface Params {
  username: string;
  application_id: number;

  onReceiveMessages?(
    messages: ProactiveMessageResponse[]
  ): void | Promise<void>;
}

export const useProactiveMessageListener = ({
  username,
  application_id,
  onReceiveMessages,
}: Params) => {
  useEffect(() => {
    let interval_id: NodeJS.Timeout | undefined;

    if (onReceiveMessages) {
      interval_id = setInterval(async () => {
        const results = await queryProactiveMessages({
          username,
          application_id,
        });

        if (results.length) {
          onReceiveMessages(results);
        }
      }, 2000);
    }

    return () => {
      if (interval_id) {
        clearInterval(interval_id);
      }
    };
  }, [username, application_id, onReceiveMessages]);
};
